
import React from "react"
import {Link} from "gatsby"
import ReactMarkdown from "react-markdown"

import Layout from "../components/layout"
import SEO from "../components/seo"
import yaml from "../data/pages/mentions_legales.data.yml"
import style from "../templates/blog-post.module.scss"


const Contact = ({ data }) => {
  return (
    <Layout>
      <SEO title={yaml.title} description={yaml.description} />
      <h2>{yaml.title}</h2>
      <ReactMarkdown className={style.markdown} source={yaml.content} />
      <Link className="btn mt-4" to="/">Retourner à l'accueil</Link>
    </Layout>
  )
}

export default Contact